module.exports = __webpack_public_path__ + "static/media/fake_me_hard.fdeacebc.png";